var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pending-widget"},[_c('Pending',{ref:"actions",attrs:{"widget-impact-range":_vm.pendOptImpactRange,"widget-sort-by":_vm.pendOptSortBy,"widget-leaders":_vm.pendOptLeader,"as-widget":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }